export default __webpack_public_path__ + "static/media/user-logo.e327041b.svg";